import React from 'react';

export default function PlayersMoney(props) {
  return <div>Players Money COmponent</div>;
}
